import { caseApi } from 'modules/cm/api';
import { ExperianCheckError } from 'modules/cm/api/cases/credit/errors';
import { CaseStatus } from 'modules/cm/pages/CaseDetailsPage/CaseDetailsPage.types';
import { getTasks } from 'modules/cm/Tasks/useCases';
import { Dispatch } from 'redux';
import { refreshCase, setCaseStatus } from '../cases/actions';
import { GetState } from '../cases/types';

export class ChangeCaseStatusError extends Error {}

const changeCaseStatus = (caseId: string, currentStatus: CaseStatus, upcomingStatus: CaseStatus) => {
  return (dispatch: Dispatch, getState: GetState) => {
    const state = getState().currentCase;
    const apiCall = caseApi(caseId).switchStatus(upcomingStatus);
    return apiCall
      .then((res) => {
        dispatch(setCaseStatus(upcomingStatus));
        refreshCase(state.data!.case.identifier)(dispatch, getState);
        getTasks(caseId)(dispatch, getState);

        const { actionsDone } = res.data;

        return Promise.resolve(actionsDone || []);
      })
      .catch((error: unknown) => {
        dispatch(setCaseStatus(currentStatus));

        if (error instanceof ExperianCheckError) {
          throw new ChangeCaseStatusError(error.message);
        }

        return Promise.reject();
      });
  };
};

export default changeCaseStatus;
